




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import validation from '@/common/element-val'
import { NewMemberModel } from '@/services/memberService'
import { VForm } from '@/services/VForm'

@Component
export default class UserForm extends Vue {
  $refs: {
    modelForm: VForm;
  }

  @Prop() Member: NewMemberModel
  @Prop() IsEditing: boolean
  roles = [{ label: 'Admin', value: 1 }, { label: 'User', value: 2 }]

  model = {
    Name: '',
    LoginId: '',
    RoleId: 1,
    Password: '',
    ConfirmPwd: ''
  }

  rules = {
    required: validation.required()
  }

  mounted () {
    this.model.Name = this.Member.Name
    this.model.LoginId = this.Member.LoginId
    this.model.RoleId = this.Member.RoleId
  }

  @Watch('Member')
  onMemberChanged (v: string) {
    this.model.Name = this.Member.Name
    this.model.LoginId = this.Member.LoginId
    this.model.RoleId = this.Member.RoleId
  }

  // if use @Emit,do not use this.$emit again, @Emit will return the function value to parent
  submit () {
    if (!this.$refs.modelForm.validate()) { return }
    this.$emit('submit', this.model)
  }
}
